export const LOAD=0
export const INITING=1
export const INITD=2

export const inactivityTimeoutDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds


// WEBPACK FOOTER //
// ./src/constants/app.js